import { c as _c } from "react/compiler-runtime";
import { DropdownMenuContent, DropdownMenuGroup, DropdownMenuItem, DropdownMenuSeparator } from "@/components/ui/dropdown-menu";
import { ValuesSchemaType } from "../schemas";
import { Checkbox } from "@/components/ui/checkbox";
type Props = {
  activeValues: ValuesSchemaType;
  inactiveValues: ValuesSchemaType;
  onChange: (value: string | number | boolean) => void;
};
export function FilterMenuList(t0) {
  const $ = _c(14);
  const {
    activeValues,
    inactiveValues,
    onChange
  } = t0;
  const hasActiveValues = activeValues.length > 0;
  const hasInactiveValues = inactiveValues.length > 0;
  const showSeparator = hasActiveValues && hasInactiveValues;
  let t1;
  if ($[0] !== activeValues || $[1] !== hasActiveValues || $[2] !== onChange) {
    t1 = hasActiveValues && <DropdownMenuGroup>{activeValues.map(value => <DropdownMenuItem className="capitalize" onSelect={_temp} key={value.value.toString()}><div onClick={e_0 => {
          e_0.stopPropagation();
          onChange(value.value);
        }}><Checkbox checked={true} size="sm" /></div>{value.decorator ?? value.label}</DropdownMenuItem>)}</DropdownMenuGroup>;
    $[0] = activeValues;
    $[1] = hasActiveValues;
    $[2] = onChange;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== showSeparator) {
    t2 = showSeparator && <DropdownMenuSeparator />;
    $[4] = showSeparator;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== hasInactiveValues || $[7] !== inactiveValues || $[8] !== onChange) {
    t3 = hasInactiveValues && <DropdownMenuGroup>{inactiveValues.map(value_0 => <DropdownMenuItem className="capitalize" onSelect={e_1 => {
        onChange(value_0.value);
      }} key={value_0.value.toString()}><div onClick={e_2 => {
          e_2.stopPropagation();
          onChange(value_0.value);
        }}><Checkbox size="sm" /></div>{value_0.decorator ?? value_0.label}</DropdownMenuItem>)}</DropdownMenuGroup>;
    $[6] = hasInactiveValues;
    $[7] = inactiveValues;
    $[8] = onChange;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t1 || $[11] !== t2 || $[12] !== t3) {
    t4 = <>{t1}{t2}{t3}</>;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
}
function _temp(e) {
  return e.preventDefault();
}